export const environment = {
	production: true,
	cloudFunctionHost: "us-central1-advanceconceptsoftware",
	firebaseConfig: {
		apiKey: "AIzaSyDWbI2iNc9CuU4FjGQN-zQ8Hqth8EPi_nQ",
  authDomain: "advanceconceptsoftware.firebaseapp.com",
  projectId: "advanceconceptsoftware",
  storageBucket: "advanceconceptsoftware.firebasestorage.app",
  messagingSenderId: "257948272033",
  appId: "1:257948272033:web:068cd424627cd23c20b7e0",
  measurementId: "G-RMJ24H34ZT"
	},
	recaptcha: {
		siteKey: "6LdwzhYnAAAAACJkPZtWZiCiFKfSLellG4MS-t5x",
	},
};
